import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, computed, ref, Ref} from "vue";
// components
import MapComponent from "@/vue/map/components/map-v2.vue";

// Images
import mapPlaceHolder from "@/images/mapPlaceHolder.png"

// Refs

export default /*#__PURE__*/_defineComponent({
  __name: 'App-v2',
  setup(__props) {

// Vue
const isMapOpen: Ref<boolean> = ref(false)

// Handlers
const handleOpenMapClick = (): void => {
	isMapOpen.value = true
	window.dispatchEvent(new Event("openMapClick"))
}

const content = window.content
const lihe = window.lihe


return { __sfc: true,isMapOpen, handleOpenMapClick, content, lihe, MapComponent, mapPlaceHolder }
}

})